import React from "react";
import filterPng from "../assets/icons/filter_png.png";
import filterDummyIcon from "../assets/images/filter_dummy_logo.png";
import dashboardContactIcon from "../assets/icons/dashboardContactIcon.png";
import dashboardNegotiationIcon from "../assets/icons/dashboardNegotiationIcon.png";
import dashboardWinIcon from "../assets/icons/dashboardWinIcon.png";
import dashboardPendingIcon from "../assets/icons/dashboardPendingIcon.png";
import dashboardInactiveIcon from "../assets/icons/dashboardInactiveIcon.png";
import dashboardClosedIcon from "../assets/icons/dashboardClosedIcon.png";

const DashboardCards = ({
  heading,
  info,
  contacted,
  pending,
  negotiation,
  inactive,
  win,
  closed,
}) => {
  return (
    <>
      <div className="relative bg-[#FFF6DE] shadow-lg h-full rounded-3xl p-4 pt-6 px-6">
        <div className="flex justify-between">
          <div>
            <div className="text-[16px] font-bold my-1">{heading}</div>
            <div className="text-[14px] text-[#828282]">{info}</div>
          </div>
          <div className="absolute right-0 top-0">
            <img src={filterPng} className="cursor-pointer" alt="first" />
          </div>
        </div>

        <div className="flex justify-center w-full mt-2 display--cards">
          <div className="w-full">
            <div className="flex p-1 px-3 py-2 rounded-lg cursor-pointer w-[100%] glasomorphism mb-3">
              <img
                src={dashboardContactIcon}
                className="w-10 object-contain"
                alt="second"
              />
              <div className="flex flex-col ml-1">
                <div className="text-[24px] font-bold">{contacted}</div>
                <div className="text-[14px]">To be contacted</div>
              </div>
            </div>

            <div className="flex glasomorphism p-1 px-3 py-2 rounded-lg cursor-pointer  mb-3">
              <img
                src={dashboardNegotiationIcon}
                className="w-10 object-contain"
                alt="forth"
              />
              <div className="flex flex-col ml-1">
                <div className="text-[24px] font-bold">{negotiation}</div>
                <div className="text-[14px]">Negotiation</div>
              </div>
            </div>

            <div className="flex glasomorphism p-1 px-3 py-2 rounded-lg cursor-pointer mb-3">
              <img
                src={dashboardWinIcon}
                className="w-10 object-contain"
                alt="sixth"
              />
              <div className="flex flex-col ml-1">
                <div className="text-[24px] font-bold">{win}</div>
                <div className="text-[14px]">Win</div>
              </div>
            </div>
          </div>
          <div className="w-full ml-4">
            <div className="flex glasomorphism p-1 px-3 py-2 rounded-lg cursor-pointer mb-3">
              <img
                src={dashboardPendingIcon}
                className="w-10 object-contain"
                alt="third"
              />
              <div className="flex flex-col ml-1">
                <div className="text-[24px] font-bold">{pending}</div>
                <div className="text-[14px]">Pending Visits</div>
              </div>
            </div>

            <div className="flex glasomorphism p-1 px-3 py-2 rounded-lg cursor-pointer mb-3">
              <img
                src={dashboardInactiveIcon}
                className="w-10 object-contain"
                alt="fifth"
              />
              <div className="flex flex-col ml-1">
                <div className="text-[24px] font-bold">{inactive}</div>
                <div className="text-[14px]">Inactive</div>
              </div>
            </div>

            <div className="flex glasomorphism p-1 px-3 py-2 rounded-lg cursor-pointer mb-3">
              <img
                src={dashboardClosedIcon}
                className="w-10 object-contain"
                alt="seventh"
              />
              <div className="flex flex-col ml-1">
                <div className="text-[24px] font-bold">{closed}</div>
                <div className="text-[14px]">Closed</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardCards;
